import React from 'react';

import LockIconBase from '../assets/lock.svg';

interface Props extends React.SVGAttributes<SVGAElement> {
    size?: number | string;
}

const LockIcon: React.FC<Props> = ({ size, ...props }) => {
    return <LockIconBase {...(size ? { width: size, height: size } : {})} {...props} />;
};

export default LockIcon;
